import { n_lesson_review } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import KeywordCard from './KeywordCard'

interface Props {
  studentName: string
  compliments: {
    compliments: any[]
    overall_compliment: string
  }
}

// TODO
const WhatYouDidGreat = ({ studentName = 'Student', compliments }: Props) => {
  const { t } = useTranslation()
  if (!compliments) return null
  console.log(compliments, 'compliments')
  return (
    <div className="mt-[40px] flex w-full flex-col items-start justify-start">
      <div className="text-[20px] font-bold text-gray-800">What you did great</div>
      <div className="test-[14px] mt-[4px] text-gray-600">
        {t(n_lesson_review.feedback_section_detail2(studentName))}
      </div>

      <div className="mt-[24px] flex w-[100%] overflow-auto">
        <div className="flex flex-row gap-x-[16px]">
          {compliments.compliments?.map((cardItem, i) => (
            <KeywordCard
              title={cardItem.title}
              subTitle={cardItem.sub_title}
              badge={cardItem.is_new ? 'New' : cardItem.is_popular ? 'Popular' : ''}
              key={`${cardItem.title}_${i}`}
            />
          ))}
        </div>
      </div>

      <div className="keep-all mt-[16px] w-full rounded-[10px] bg-gray-50 p-[16px]">
        {compliments.overall_compliment || ''}
      </div>
    </div>
  )
}

export default WhatYouDidGreat
